export function removeNameSpaceIfNeeded(tagName, options) {
    if (!options.ignoreNameSpace) {
        return tagName;
    }
    const colonIndex = tagName.indexOf(':');
    if (colonIndex !== -1) {
        tagName = tagName.slice(colonIndex + 1);
    }
    return tagName;
}
//# sourceMappingURL=removeNameSpaceIfNeeded.js.map